import { isPlatformBrowser, isPlatformServer } from "@angular/common";

import {
    computed,
    inject,
    Injectable,
    PLATFORM_ID,
    Signal,
} from "@angular/core";

import { IS_MOBILE_FROM_SSR } from "@hermes/core-app-core";

import { isMobileDevice } from "@hermes/utils-generic-helpers";
import { BreakpointService } from "@hermes/utils-generic-services-user-interface";

@Injectable({
    providedIn: "root",
})
export class UserAgentPlatformService {
    private platformId = inject(PLATFORM_ID);
    private isMobileFromServer = inject(IS_MOBILE_FROM_SSR, { optional: true });
    private breakpointService = inject(BreakpointService);

    public readonly isMobileSignal: Signal<boolean> = computed(() => {
        if (isPlatformBrowser(this.platformId)) {
            return this.breakpointService.isMobile() ?? false;
        }
        if (isPlatformServer(this.platformId)) {
            return this.isMobileFromServer ?? false;
        }
        return false;
    });

    public readonly isDesktopSignal: Signal<boolean> = computed(
        () => !this.isMobileSignal(),
    );

    /**
     * Indicates whether the current platform is a real mobile device based on the User-Agent only.
     * Unlike `isMobileSignal`, this does not consider viewport breakpoints or responsive layout.
     * It strictly checks the device type (SSR token or UserAgent parsing).
     */
    public readonly isRealMobile = computed(() => {
        if (isPlatformServer(this.platformId)) {
            return this.isMobileFromServer ?? false;
        }
        if (isPlatformBrowser(this.platformId)) {
            return isMobileDevice(window.navigator.userAgent);
        }
        return false;
    });
}
